import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggerService } from '@lbmx/phoenix-lib-core';
import { SpinnerService, ToastrNotificationService } from '@lbmx/phoenix-lib-utils';
import { TranslocoService } from '@ngneat/transloco';
import { Subscription } from 'rxjs';
import { IConfigCountry, IConfigProvince, IDropDown, INewMemberLocationForm } from 'src/app/dtos/group/group.dto';
import { OnboardingService } from 'src/app/services/onboarding/onboarding.service';

@Component({
  selector: 'app-new-member-location',
  templateUrl: './new-member-location.component.html',
  styleUrls: ['./new-member-location.component.scss']
})
export class NewMemberLocationComponent implements OnInit, OnDestroy {

  @Output() public closeLocationDialog = new EventEmitter();
  public subscriptions: Subscription[] = [];
  public countriesDropDown: IDropDown[];
  public provincesDropDown: IDropDown[];
  public provinces: IConfigProvince[];
  public entryId = -1;
  public answersDropDown: IDropDown[] = [{
    label: 'Yes',
    value: 'Yes',
  }, {
    label: 'No',
    value: 'No',
  }];

  public newMemberLocationForm: FormGroup = this.formBuilder.group(
    {
      legalcompanyName: ['', [Validators.required]],
      operatingName: ['', [Validators.required]],
      address: ['', [Validators.required]],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      province: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      mainPhone: ['', [Validators.required]],
      discountsQuestion: ['', [Validators.required]],
    }
  );

  constructor(private route: ActivatedRoute,
              private router: Router,
              private formBuilder: FormBuilder,
              private loggerService: LoggerService,
              private toastSrv: ToastrNotificationService,
              private spinnerService: SpinnerService,
              private onboardingService: OnboardingService,
              private translocoService: TranslocoService) { }

  public ngOnInit(): void {
    this.getCountries();
    this.getProvinces();
  }

  public getCountries() {
    this.onboardingService.getCountries()
      .pipe()
      .subscribe((val) => {
        this.countriesDropDown = val.map(
          (country: IConfigCountry): IDropDown => {
            return {
              label: country.countryName,
              value: country.countryCode.trim(),
            };
          }
        );
      });
  }

  public getProvinces() {
    this.onboardingService.getProvinces()
      .pipe()
      .subscribe((val) => {
        this.provinces = val;
      });
  }

  public onCountryDropDownSelect() {
    const filteredProv = this.provinces.filter(prov => prov.countryCode === this.newMemberLocationForm.get('country').value);
    this.provincesDropDown = filteredProv.map((province: IConfigProvince): IDropDown => {
      return {
        label: province.provinceName,
        value: province.provinceCode.trim(),
      };
    });
  }

  public ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    this.spinnerService.off();
  }

  public prefillForm(location: INewMemberLocationForm) {
    this.entryId = location.id;
    this.newMemberLocationForm.controls.legalcompanyName.setValue(location.legalcompanyName);
    this.newMemberLocationForm.controls.operatingName.setValue(location.operatingName);
    this.newMemberLocationForm.controls.address.setValue(location.address);
    this.newMemberLocationForm.controls.city.setValue(location.city);
    this.newMemberLocationForm.controls.country.setValue(location.country);
    this.onCountryDropDownSelect();
    this.newMemberLocationForm.controls.province.setValue(location.province);
    this.newMemberLocationForm.controls.postalCode.setValue(location.postalCode);
    this.newMemberLocationForm.controls.mainPhone.setValue(location.mainPhone);
    this.newMemberLocationForm.controls.discountsQuestion.setValue(location.discountsQuestion);
  }

  public save() {
    this.closeLocationDialog.emit({
      id: this.entryId,
      legalcompanyName: this.newMemberLocationForm.value.legalcompanyName,
      operatingName: this.newMemberLocationForm.value.operatingName,
      address: this.newMemberLocationForm.value.address,
      city: this.newMemberLocationForm.value.city,
      country: this.newMemberLocationForm.value.country,
      province: this.newMemberLocationForm.value.province,
      postalCode: this.newMemberLocationForm.value.postalCode,
      mainPhone: this.newMemberLocationForm.value.mainPhone,
      discountsQuestion: this.newMemberLocationForm.value.discountsQuestion,
    });
    this.entryId = -1;
    this.newMemberLocationForm.reset();
  }

  public handleCancel() {
    this.entryId = -1;
    this.closeLocationDialog.emit(null);
    this.newMemberLocationForm.reset();
  }
}
